import React, {useState} from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import "../Curriculum.css";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {toast} from "react-toastify";

/**
 * EntityForm - Bölüm, Ders ve diğer entity'ler için ortak form component
 *
 * @param {Object} props
 * @param {number} props.index - Entity'nin sıra numarası
 * @param {Object} [props.data] - Düzenlenecek data (opsiyonel, yeni kayıt için null)
 * @param {function} props.cancel - İptal callback'i
 * @param {function} props.save - Kaydetme callback'i
 * @param {string} [props.entityName="Entity"] - Entity'nin adı (Bölüm, Ders, vs.)
 * @param {string} [props.titlePlaceholder="Başlık Girin"] - Başlık input placeholder
 * @param {string} [props.descriptionLabel="Açıklama"] - Açıklama label metni
 * @param {string} [props.descriptionPlaceholder="Açıklama girin"] - Açıklama placeholder
 */
const EntityForm = (props) => {
    const {
        index,
        cancel,
        save,
        entityName = "Entity",
        titlePlaceholder = "Başlık Girin",
        descriptionLabel = "Açıklama",
        descriptionPlaceholder = "Açıklama girin"
    } = props;

    const defaultData = {
        title: '',
        description: '',
        objectIndex: 1,
    };

    const [data, setData] = useState(!GeneralUtils.isNullOrEmpty(props.data) ? props.data : defaultData);

    const handleSave = () => {
        if (GeneralUtils.isNullOrEmpty(data.title)) {
            return toast.warn('Lütfen başlık alanını doldurun.');
        }
        const dataToSave = {
            ...data,
            description: data.description?.trim() === '' ? null : data.description
        };
        save(dataToSave);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value});
    };

    return (
        <div className="flex flex-column gap-2">
            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>
                    {entityName} {index + 1}:
                </p>
                <InputText
                    name="title"
                    type="text"
                    value={data.title}
                    onChange={handleChange}
                    className="inputtext p-inputtext-sm"
                    placeholder={titlePlaceholder}
                />
            </div>

            <div className="flex flex-column gap-2">
                <p style={{minWidth: "50px", fontWeight: "600"}}>
                    {descriptionLabel}
                </p>
                <InputTextarea
                    name="description"
                    value={data.description || ''}
                    onChange={handleChange}
                    rows={3}
                    autoResize
                    className="inputtext p-inputtext-sm"
                    placeholder={descriptionPlaceholder}
                />
            </div>

            <div className="flex justify-content-end gap-2">
                <Button label="İptal" onClick={cancel} outlined size="small"/>
                <Button label="Kaydet" onClick={handleSave} raised size="small"/>
            </div>
        </div>
    );
};

export default EntityForm;
